import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { ClientPublicWrapper } from 'src/components/layout/client/ClientPublicWrapper'
import FailedImage from 'src/assets/images/failed.png'

const PartnerDisabledPageComponent = () => {
  return (
    <ClientPublicWrapper>
      <div css={tw`h-full flex flex-col justify-between`}>
        <img src={FailedImage} css={tw`h-[220px] w-[280px] self-center`} />
        <div>
          <Typography css={tw`mt-4 text-center`} variant="h2">
            Partner Not Found
          </Typography>
          <Typography css={tw`my-4 text-center text-shades-400`}>
            The partner you're trying to onboard with has been disabled. Please contact support for
            assistance.
          </Typography>
        </div>
      </div>
    </ClientPublicWrapper>
  )
}

export const PartnerDisabledPage = memo(PartnerDisabledPageComponent)
